import { SettlementPeriodController } from './settlement-period.controller';
import * as SettlementPeriodRoutes from './settlement-period.routes';
import { IControllerConstructor } from 'angular';

/**
 * The entry point the charge accounts module
 */
export const initialise = () => {

  angular.module('app.settlement-period', [
    'pascalprecht.translate',
    'actora.services',
    'app.layout',
    'app.components',
    
  ]).controller('settlementPeriodController', <IControllerConstructor>SettlementPeriodController);

  SettlementPeriodRoutes.initialise();
};